import { api } from "..";

const endpoint = "/api/ra-payments";

export const getRaPaymentList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getRaPaymentById = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const getRaPaymentsByReceipt = (receiptAcknowledgementId) => {
  return api.get(`${endpoint}/by-receipt/${receiptAcknowledgementId}`);
};

export const createRaPayment = (data) => {
  return api.post(`${endpoint}`, data);
};

// Editing PaymentDate on an actively-scheduled installment reassigns it (server-side) to whichever
// open run matches the new date, or creates a new one — see ScheduledPaymentService.ReassignInstallmentDateAsync.
export const updateRaPayment = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const deleteRaPayment = (id) => {
  return api.delete(`${endpoint}/${id}`);
};
